import { createRoute } from '@tanstack/react-router';

import { useMaterialSearchStore } from '$/components/core/Collection/MaterialSearch/store/useMaterialSearchStore';
import { FavoriteDashboard } from '$/pages/DashboardPages/pages/Favorite';
import { BaseRouteLayout } from '$/routes/Layouts/BaseRouteLayout';
import { STANDARD_STALE_TIME } from '$/services/constants';
import { useFavoriteStore } from '$/stores/useFavoriteStore';

export const FavoritesRoute = createRoute({
  getParentRoute: () => BaseRouteLayout,
  path: '/favorites',
  component: FavoriteDashboard,
  onEnter: () => {
    useMaterialSearchStore.setState({ query: '', dropdownVisible: false });
  },
  loader: () => {
    void useFavoriteStore.getState().getFavorites();
  },
  onLeave: () => {
    useFavoriteStore.setState({ activeFolderId: null });
  },
  staleTime: STANDARD_STALE_TIME,
});
